import React from "react";
import { cn } from "../cn";

export type IGrid2Props = {
  children: React.ReactNode;
  className?: string;
  innerContainerClassName?: string;
  style?: React.CSSProperties;
  id?: string;
}

export const Grid2 = ({children, innerContainerClassName, className, ...props}: IGrid2Props) => {
  return <div className={cn(
    'px-5 py-8 md:px-10 lg:px-20 xl:px-[120px]',
    className,
  )} {...props}>
    <div className={cn('max-w-[1200px] m-auto', innerContainerClassName)}>
      {children}
    </div>
  </div>
}